import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDonViHanhChinhActionTypes } from "../../action-types/category/IDonViHanhChinhActions";
import { IDonViHanhChinhReducer } from "../../reducer-model/category/IDonViHanhChinhReducer";

const iniState: IDonViHanhChinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  donViHanhChinhs: [],
};

export const donViHanhChinhReducer = (
  state: IDonViHanhChinhReducer = iniState,
  action: IDonViHanhChinhActionTypes
): IDonViHanhChinhReducer => {
  switch (action.type) {
    case "DON_VI_HANH_CHINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DON_VI_HANH_CHINH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        donViHanhChinhs: action.payload,
      };
    case "DON_VI_HANH_CHINH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
